export const lookupEndpoint = {
  user: (data: string | null) => ({
    params: { search: data },
    endPoint: "/users/people_lookup",
    type: "user",
  }),
  leadOwner: (data: string | null) => ({
    params: { search: data, type: "lead_owner" },
    endPoint: "/users/lead_person_lookup",
    type: "leadOwner",
  }),
  leadSourceName: (data: string | null) => ({
    params: { search: data, type: "lead_referrer" },
    endPoint: "/users/lead_person_lookup",
    type: "leadSourceName",
  }),
  closer: (data: string | null) => ({
    params: { q: data },
    endPoint: "/users/project_mentors",
    type: "closer",
  }),
  seller: (data: string | null) => ({
    params: { q: data },
    endPoint: "/users/project_consultants",
    type: "seller",
  }),
  location: (data: string | null) => ({ params: { q: data }, endPoint: "/projects/cities", type: "location" }),
  installer: (data: string | null) => ({
    params: { q: data },
    endPoint: "/installers/autocomplete",
    type: "installer",
  }),
  team: (data: string | null) => ({
    params: { q: data },
    endPoint: "/teams/autocomplete",
    type: "team",
  }),
  utility: (data: string | null) => ({
    params: { q: data },
    endPoint: "/utilities/autocomplete",
    type: "utility",
  }),
  teamUser: (data: string | null) => ({
    params: { search: data },
    endPoint: "/users/team_users_autocomplete",
    type: "teamUser",
  }),
  orgTeamUser: (data: string | null) => ({
    params: { search: data },
    endPoint: "/enterprise/org_team_users_autocomplete",
    type: "orgTeamUser",
  }),
  orgTeamSeatedUser: (data: string | null) => ({
    params: { search: data },
    endPoint: "/enterprise/seated_users_autocomplete",
    type: "orgTeamSeatedUser",
  }),
  enterprise: (data: string | null) => ({
    params: { partial: data },
    endPoint: "/projects/enterprise_lookup",
    type: "enterprise",
  }),
};
